export let application;

export function setApplication(value) {
  application = value;
}
